﻿document.addEventListener('CookieConsent.change', (e: Event) => {
    const customEvent = e as CustomEvent;
    const consentedCookies = customEvent.detail?.instance.getConsentedCookies();

    const value = consentedCookies && consentedCookies.length > 0 ? "granted" : "denied";
    const g = window.gtag;
    if (typeof g === "function") {
        g("consent", "update", {
            ad_storage: value,
            analytics_storage: value,
            ad_personalization: value
        });        
    }
    const c = window.clarity;
    if (typeof c === "function") {
        c('consentv2', {
            ad_Storage: value,
            analytics_Storage: value
        });
    }
});